module.exports = __webpack_public_path__ + "img/如何新增节点.60d5f0e5.gif";